import { Link, useLoaderData } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DealMappingsSection } from "./deal-mappings-section";
import { DealSyncSection } from "./deal-sync-section";

export function DealSyncPage() {
  const {
    dealSyncSettings,
    dealSyncHistory,
    totalLocalDeals,
    mappings,
    mappableColumns,
    hubspotProperties,
  } = useLoaderData({
    from: "/_authenticated/data-sync/deals",
  }) as {
    dealSyncSettings: {
      intervalMs: number;
      lastSyncedAt: string | null;
      schedulerActive: boolean;
      backfillCompletedAt: string | null;
    };
    dealSyncHistory: any[];
    totalLocalDeals: number;
    mappings: any[];
    mappableColumns: { name: string; type: string }[];
    hubspotProperties: { name: string; label: string; type: string; category: string }[];
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Deal Sync"
        description="Mirror HubSpot deals to local database"
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/data-sync">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Data Sync
            </Link>
          </Button>
        }
      />

      <Tabs defaultValue="sync">
        <TabsList>
          <TabsTrigger value="sync">Sync</TabsTrigger>
          <TabsTrigger value="mappings">Mappings</TabsTrigger>
        </TabsList>

        <TabsContent value="sync">
          <DealSyncSection
            initialSettings={dealSyncSettings}
            initialHistory={dealSyncHistory}
            totalDeals={totalLocalDeals}
          />
        </TabsContent>

        <TabsContent value="mappings">
          <DealMappingsSection
            initialMappings={mappings}
            mappableColumns={mappableColumns}
            hubspotProperties={hubspotProperties}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
